import { HttpClient } from '../HttpClient';
/**
 * * Get User Type
 */

export const GetUserType = async () => {
  try {
    const { data } = await HttpClient.get(`api/jobrequisitions/usertype`);
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
